import React from 'react';
import { Card, SkeletonContent, SkeletonLine, } from '@one-thd/sui-atomic-components';
/**
 * Skeleton for Spend Across Accounts Section
 */
export var SpendAcrossAccountsSkeleton = function () {
    return (React.createElement("div", { className: "sui-grid md:sui-grid-cols-1 lg:sui-grid-cols-3 sui-gap-6", "data-testid": "spend-across-accounts-skeleton" },
        React.createElement(Card, { CardContentProps: {
                initialSize: 'full',
            }, "data-testid": "spend-across-accounts-card-skeleton" },
            React.createElement(SkeletonContent, { grow: true, orientation: "horizontal", "data-testid": "spend-across-accounts-card-skeleton-content" },
                React.createElement("div", { className: "sui-w-full" },
                    React.createElement(SkeletonLine, { numberOfLines: 2, fullWidth: true })))),
        React.createElement(Card, { CardContentProps: {
                initialSize: 'full',
            }, "data-testid": "spend-across-accounts-card-skeleton" },
            React.createElement(SkeletonContent, { orientation: "horizontal", "data-testid": "spend-across-accounts-card-skeleton-content" },
                React.createElement("div", { className: "sui-w-full" },
                    React.createElement(SkeletonLine, { numberOfLines: 2, fullWidth: true })))),
        React.createElement(Card, { CardContentProps: {
                initialSize: 'full',
            }, "data-testid": "spend-across-accounts-card-skeleton" },
            React.createElement(SkeletonContent, { orientation: "horizontal", "data-testid": "spend-across-accounts-card-skeleton-content" },
                React.createElement("div", { className: "sui-w-full" },
                    React.createElement(SkeletonLine, { numberOfLines: 2, fullWidth: true }))))));
};
var SpendByIndividualAccountsCardSkeleton = function () { return (React.createElement(Card, { CardContentProps: {
        initialSize: 'full',
    }, "data-testid": "spend-by-individual-accounts-card-skeleton" },
    React.createElement(SkeletonContent, { grow: true, orientation: "horizontal", "data-testid": "spend-by-individual-accounts-card-skeleton-content" },
        React.createElement("div", { className: "sui-w-full" },
            React.createElement(SkeletonLine, { numberOfLines: 2, fullWidth: true }))))); };
/**
 * Skeleton for Spend By Individual Accounts Section
 */
export var SpendByIndividualAccountsSkeleton = function () {
    return (React.createElement("div", { className: "sui-grid md:sui-grid-cols-1 lg:sui-grid-cols-2 sui-gap-6" },
        React.createElement(SpendByIndividualAccountsCardSkeleton, null),
        React.createElement(SpendByIndividualAccountsCardSkeleton, null),
        React.createElement(SpendByIndividualAccountsCardSkeleton, null)));
};
